import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Tooltip, Typography } from '@mui/material';
import { InlineDiv, WrapperTruncate, InlineButton } from './TruncateTextStyles';

const TruncateText = ({
  text,
  className,
  textVariant,
  lines,
  tooltip,
  tooltipPlacement,
  wrapperClassName,
  button,
  onClick,
}) => {
  const tooltipTitle = tooltip || text;
  // By default if button is not setted as false, if lines == 1 then return
  // it inside a wrapper. To support latest implementations of TruncateText for buttons
  if (lines === 1 && button) {
    return (
      <WrapperTruncate className={wrapperClassName} aria-label={text}>
        <InlineButton
          className={className}
          aria-hidden
          tabIndex="-1"
          onClick={onClick}
        >
          {text}
        </InlineButton>
      </WrapperTruncate>
    );
  }

  if (lines === 1 && !button) {
    return (
      <Tooltip
        title={tooltipTitle}
        enterDelay={1500}
        enterNextDelay={1500}
        placement={tooltipPlacement}
        arrow
      >
        <InlineDiv
          aria-label={tooltipTitle}
          className={className}
          onClick={onClick}
          data-test-id={text}
          role="button"
        >
          {text}
        </InlineDiv>
      </Tooltip>
    );
  }

  // returns if default
  return (
    <Tooltip
      title={tooltipTitle}
      enterDelay={1500}
      placement={tooltipPlacement}
      arrow
    >
      <Typography
        noWrap
        variant={textVariant}
        className={className}
        data-test-id={text}
      >
        {text}
      </Typography>
    </Tooltip>
  );
};

TruncateText.defaultProps = {
  lines: null,
  tooltipPlacement: 'right',
  wrapperClassName: '',
  button: true,
};

TruncateText.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  textVariant: PropTypes.string,
  // eslint-disable-next-line react/no-unused-prop-types
  width: PropTypes.number,
  lines: PropTypes.number,
  button: PropTypes.bool, // wraps inside a button
  wrapperClassName: PropTypes.string,
  className: PropTypes.string,
  tooltipPlacement: PropTypes.string,
  tooltip: PropTypes.string,
  onClick: PropTypes.func,
};

export default memo(TruncateText);
